module.exports = __webpack_public_path__ + "img/制御工学7_3_4.a28e0cb2.png";